import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import image from "../login-page3.png";
import aclService from "../services/aclService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FaMicrosoft } from "react-icons/fa";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import adminService from "../services/adminService";

const API_URL = process.env.REACT_APP_API_URL_V;
const Login = ({ setIslogged }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  //  const { currentMode } = useStateContext();
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [loginSuccess, setLoginSuccess] = useState(false);
  const fetchData = async () => {
    try {
      let profile = localStorage.getItem("userData");
      let uobj = JSON.parse(profile);
      console.log(uobj);
      // setUserDataInLocalStorage(data);
      if (uobj) {
        setLoginSuccess(true);
        setErrorMessage("");
        setIslogged(true);
        navigate("/dashboard");
      } else {
        setLoginSuccess(false);
        // setErrorMessage("");
        setIslogged(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData(); // Call the function to fetch data
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleAD = async () => {
    let ssourl = await adminService.getssourl({});

    console.log(ssourl, "ssourl");
    window.location.replace(ssourl);
  };
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);
    try {
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (data.success) {
        setErrorMessage("Password reset link has been sent to your email.");
      } else {
        setErrorMessage(data.message || "An error occurred.");
        setIsButtonDisabled(false);
      }
    } catch (error) {
      setErrorMessage("An error occurred.");
      console.error("Error:", error);
      setIsButtonDisabled(false);
    }
  };
  const handleLogin = async (event) => {
    try {
      event.preventDefault();
      const response = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Login failed");
      }

      const data = await response.json();
      console.log(data);
      if (data.success == false) {
        console.log("workingh-------");
        toast.error(`${data["message"]}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      // let aclData = [];

      // if (data.role !== "superadmin") {
      //   aclData = await fetchAclData(data._id);
      // }

      // const onloadAcl = aclData.find((o) => o.isDefault === true) || {};
      if (data.firstLogin) {
        // Show message to user
        setErrorMessage("Please check your email to set up your password.");
        setShowResetPassword(true);
        return;
      }

      if (data.token) {
        setUserDataInLocalStorage(data);
        setLoginSuccess(true);
        setErrorMessage("");
        setIslogged(true);
        navigate("/dashboard");
        // window.location.reload();
      }
    } catch (error) {
      console.error("Login error:", error);
      setLoginSuccess(false);
      setErrorMessage(error.message || "Login failed: An error occurred");
    }
  };

  const fetchAclData = async (userId) => {
    try {
      const aclData = await aclService.getacls({ user: userId });
      return aclData.length ? aclData[0]["awsAccounts"] : [];
    } catch (error) {
      console.error("Error fetching ACL data:", error);
      return [];
    }
  };

  const setUserDataInLocalStorage = (userData) => {
    const userDataObject = {
      email: credentials.username,
      _id: userData._id,
      firstname: userData.firstname,
      lastname: userData.lastname,
      mobile: userData.mobile,
      dial_code: userData.dial_code,
      username: userData.username,
      role: userData.role,
      status: userData.status,
      theme: userData.theme,
    };

    // Only stringify and store the acl object if it's not empty
    // if (Object.keys(aclData).length !== 0) {
    //   userDataObject.acl = JSON.stringify(aclData);
    // }

    localStorage.setItem("accesstoken", userData.token);
    localStorage.setItem("refreshtoken", userData.refreshToken);
    localStorage.setItem("userData", JSON.stringify(userDataObject));
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  return (
    <>
      <>
        <div className="customize-container">
          <div className="customize-forms-container">
            <div className="customize-signin-signup">
              {showForgotPassword ? (
                <div>
                  <form
                    className="sign-in-form form"
                    onSubmit={handleForgotPassword}
                  >
                    {/* <img className="ml-4 mb-4 h-10 w-auto" src="/docbox.png" alt="Logo" /> */}
                    <button
                      className="btn"
                      onClick={() => setShowForgotPassword(false)}
                      style={{ color: "#696868" }}
                    >
                      <FaArrowAltCircleLeft size={25} />
                    </button>

                    <h2 className="customize-title">Forgot Password</h2>

                    <div className="customize-input-field">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className=" mr-5"
                        color="gray"
                      />
                      <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="email"
                        value={email}
                        onChange={handleEmailChange}
                      />
                    </div>

                    <div>
                      <button
                        disabled={isButtonDisabled}
                        type="submit"
                        className={`customize-btn solid  ${
                          isButtonDisabled ? "cursor-not-allowed" : ""
                        }`}
                        style={{
                          cursor: isButtonDisabled ? "not-allowed" : "pointer",
                        }}
                      >
                        Send Reset Link
                      </button>

                      {/* <button
                      disabled={isButtonDisabled}
                      type="submit"
                      className={`flex justify-center mx-auto rounded-md bg-[#3E4A51] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 w-80 ${
                        isButtonDisabled ? "cursor-not-allowed" : ""
                      }`}
                      onClick={handleForgotPassword}
                    >
                      Send Reset Link
                    </button> */}
                    </div>
                  </form>
                </div>
              ) : (
                <form onSubmit={handleLogin} className="sign-in-form form">
                  {/* <img
                    className="ml-4 mb-4 h-10 w-auto"
                    src="/docbox.png"
                    alt="Logo"
                  /> */}
                  <h2 className="customize-title">Sign In</h2>

                  <div className="customize-input-field">
                    {/* <FontAwesomeIcon
                      icon={faUser}
                      className=" mr-5"
                      color="gray"
                    /> */}
                    <span
                      style={{
                        mask: `url(/icons/User-login-icon.svg) center no-repeat`,
                        WebkitMask: `url(/icons/user-login-icon.svg) center no-repeat`,
                        maskSize: "contain", // Adjust the mask size here
                        WebkitMaskSize: "contain",
                        display: "block",
                        width: "20px",
                        height: "20px",
                        marginRight: "5px",
                        backgroundColor: "#696868",
                        transition: "background-color 0.3s",
                        marginRight: "8px",
                      }}
                    ></span>

                    <input
                      id="username"
                      name="username"
                      type="text"
                      placeholder="Username"
                      value={credentials.username}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="customize-input-field">
                    {/* <FontAwesomeIcon
                      icon={faLock}
                      className=" mr-5"
                      color="gray"
                    /> */}
                    <span
                      style={{
                        mask: `url(/icons/lock.svg) center no-repeat`,
                        WebkitMask: `url(/icons/lock.svg) center no-repeat`,
                        maskSize: "contain", // Adjust the mask size here
                        WebkitMaskSize: "contain",
                        display: "block",
                        width: "25px",
                        height: "25px",
                        backgroundColor: "#696868",
                        transition: "background-color 0.3s",
                        marginRight: "5px",
                      }}
                    ></span>
                    <input
                      id="password"
                      name="password"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Password"
                      value={credentials.password}
                      onChange={handleInputChange}
                    />
                    <FontAwesomeIcon
                      icon={showConfirmPassword ? faEyeSlash : faEye}
                      className="toggle-password-icon"
                      style={{ color: "gray" }}
                      onClick={toggleConfirmPasswordVisibility}
                    />
                  </div>
                  <a
                    href="#"
                    className="text-gray-600 hover:underline forgot-password "
                    onClick={() => setShowForgotPassword(true)}
                  >
                    Forgot Password?
                  </a>
                  <input
                    type="submit"
                    defaultValue="Login"
                    className="customize-btn solid mb-4"
                  />
                  <div class="container">
                    <div class="d-flex align-items-center flex-column flex-md-row">
                      <p className="customize-social-text mb-2 mb-md-0">
                        Or Sign in with
                      </p>
                      <div className="customize-social-media">
                        <button
                          type="button"
                          className="btn btn-square bg-white "
                          onClick={handleAD}
                        >
                          <img
                            src="/Microsoft_logo.png"
                            className="microsoft-logo"
                            alt="logo"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
              {errorMessage && (
                <p className="text-red-500 text-center mt-4">{errorMessage}</p>
              )}

              <form action="" className="forgot-password-form form">
                <h2 className="title">Forgot Password</h2>
                <div className="input-field">
                  <i className="fas fa-envelope" />
                  <input type="email" placeholder="Email" />
                </div>
                <input
                  type="submit"
                  defaultValue="Reset Password"
                  className="customize-btn solid"
                />
              </form>
            </div>
          </div>
          <div className="panels-container">
            <div className="panel left-panel">
              <div className="content">
                <h3
                  style={{
                    marginLeft: "0px",
                    marginRight: "80px",
                    lineHeight: "1.5",
                    marginBottom: "20px",
                  }}
                >
                  Welcome to
                </h3>

                <img
                  src="/doclogo-vert-white.png"
                  className="customize-image"
                  alt="logo"
                />
                <div className="" style={{ marginTop: "20px" }}>
                  <span className="customize-text">
                    Streamlines file and folder management on computers
                  </span>
                  {/* <span class="break"> */}
                  <br />
                  <span className="customize-text">
                    or networks, boosting user efficiency and control
                  </span>
                  <br />
                  {/* </span> */}
                  <span
                    className="customize-text-2"
                    style={{ paddingLeft: "-30px" }}
                  >
                    over digital content
                  </span>
                </div>
              </div>

              {/* <img src="/cloudbg.png" className="customize-image" alt="logo" /> */}
            </div>
          </div>
          <ToastContainer />
        </div>
      </>
    </>
  );
};

export default Login;
